import React, { useState, useCallback } from "react";
import CloseIcon from "@material-ui/icons/Close";
import Information from "./../../../svg/information1.svg";
import { imageUrlFor } from "../../../lib/image-url";
import { buildImageObj } from "../../../lib/helpers";
import BlockContent from "../../block-content";
import YouTube from "react-youtube";

const InformationPopup = React.memo(props => {
  const [isVisible, setIsVisible] = useState(false);
  const setVisible = useCallback(() => setIsVisible(!isVisible), [isVisible]);

  const youtubeOptions = {
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0
    }
  };

  return (
    <>
      <Information onClick={setVisible} />
      {isVisible && (
        <>
          <div className="vitalValues__labelGrid--box">
            <div className="vitalValues__labelGrid--closeButton">
              <CloseIcon onClick={setVisible} />
            </div>
            <h1>{props.title}</h1>
            {props.isGlands && (
              <div className="vitalValues__imageGrid">
                {props.glandsImages.map((image, index) => {
                  return (
                    <div className="vitalValues__imageGrid--image" key={index}>
                      <img
                        style={{ width: "100%" }}
                        src={imageUrlFor(buildImageObj(image)).url()}
                      />
                    </div>
                  );
                })}
              </div>
            )}
            {props.isBreathing && <>{props.body && <BlockContent blocks={props.body || []} />}</>}

            {props.isTemp && (
              <div className="vitalValues__video">
                <YouTube videoId={props.youtubeId} opts={youtubeOptions} />
              </div>
            )}
          </div>
          <div className="informationBackground" onClick={setVisible}></div>
        </>
      )}
    </>
  );
});

export default InformationPopup;
